module.exports = __webpack_public_path__ + "img/10b9818.png";